<template lang="pug">
	VuePdfApp(:pdf="src")
</template>

<script>

import VueTypes from 'vue-types';
import Loader from 'app-core/Loader.vue';
import 'vue-pdf-app/dist/icons/main.css';

export default {
	name: 'pdf-viewer',
	components: {
		VuePdfApp: () => ({
			component: import(/* webpackChunkName: "pdf-viewer" */ 'vue-pdf-app'),
			loading: Loader,
		})	
	},
	props: {
		src: VueTypes.string.def(null)
	}
};

</script>
